import { Button } from '@/components/ui/button';
import { DropdownMenuItemCopy } from '@/components/ui/buttons/copy-button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { useCustomerBasis } from '@/features/customer-detail/hooks/use-customer-basis';
import { DropdownMenuItemCreateTask } from '@/features/tasks/components/dropdown-menu-item-create-task';
import { useLocale } from '@/lib/hooks/use-locale';
import { SearchEntity } from '@/server/types/search-types';
import type { SrSalesOrderType } from '@plato/data/starrocks/types';
import { EllipsisVerticalIcon } from 'lucide-react';
import { DropdownMenuItemDelete, DropdownMenuItemRelease } from './quote-order-dropdown-menu-items';

type Props = {
    type: SrSalesOrderType;
    transactionId: string;
    customerId: string;
    onDelete?: () => void;
    displayIdentifier?: string;
};

export const QuoteOrderActionDropdownMenu: React.FC<Props> = ({
    onDelete,
    transactionId,
    type,
    customerId,
    displayIdentifier,
}) => {
    const { t } = useLocale('quotes-orders-actions');

    const { data: customerBasis, isLoading } = useCustomerBasis({
        customerId,
    });

    return (
        <div className="relative">
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button
                        variant="icon"
                        icon={EllipsisVerticalIcon}
                        isLoading={isLoading}
                        disabled={isLoading}
                        isDisabled={isLoading}
                    />
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="empty:hidden">
                    {displayIdentifier && (
                        <DropdownMenuItemCopy textToCopy={displayIdentifier} className="sm:hidden" />
                    )}
                    <DropdownMenuItemCreateTask
                        links={[
                            {
                                modelId: transactionId,
                                modelType:
                                    type === 'ORDER' ? SearchEntity.SalesOrder : SearchEntity.SalesQuote,
                                title: transactionId,
                            },
                            {
                                modelId: customerId,
                                modelType: SearchEntity.Customer,
                                title: customerBasis?.customerName || '',
                            },
                        ]}
                    />
                    <DropdownMenuItemRelease transactionId={transactionId} type={type as SrSalesOrderType} />
                    <DropdownMenuItemDelete onDelete={onDelete} transactionId={transactionId} type={type} />
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
};
